module.exports = __webpack_public_path__ + "img/perforaciones_16-9_640.b8bfbf23.webp";